import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import Navigation from "../navigation"

import * as styles from "./styles.module.scss"

const CtaNavigation = ({ links, smallScreenMenuClick }) => {
  return !links ? null : (
    <Navigation
      className={classNames(`cta_navigation`, styles.cta_navigation)}
      links={links}
      onClick={smallScreenMenuClick}
      activeState={false}
      cta={true}
    />
  )
}

CtaNavigation.propTypes = {
  links: PropTypes.array,
  smallScreenMenuClick: PropTypes.func
}

export default CtaNavigation
